const primaryMain = '#4F2683';
const primaryMainOpacity = 'rgba(79, 38, 131, 0.9)';
const secondaryMain = '#2B174E';
const secondaryMainOpacity = 'rgba(43, 23, 78, 0.5)';
const secondaryLight = '#FCB813';
const tertiaryMain = '#2B174E';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
